var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geofence-list-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"item-name one-liner"},[_vm._v("\n    "+_vm._s(_vm.namedLocation.name)+"\n  ")]),_c('div',{staticClass:"item-address one-liner"},[_vm._v("\n    "+_vm._s(_vm.address)+"\n  ")]),_c('div',{staticClass:"dropdown-option-arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }